import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Cookie, X } from "lucide-react";

export const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem("ta_cookie_ok");
    if (!accepted) {
      const t = setTimeout(() => setVisible(true), 900);
      return () => clearTimeout(t);
    }
  }, []);

  const accept = () => {
    localStorage.setItem("ta_cookie_ok", "1");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-4 inset-x-4 md:left-6 md:right-auto md:max-w-md z-[60] card-surface bg-[#121212]/95 backdrop-blur-xl p-5 shadow-2xl"
    >
      <div className="flex items-start gap-3">
        <Cookie className="h-5 w-5 text-brand-red shrink-0 mt-0.5" />
        <div className="flex-1">
          <p className="text-sm text-white/80 leading-relaxed">
            Questo sito utilizza i cookie tecnici e di terze parti. Per maggiori
            informazioni consulta la nostra{" "}
            <Link to="/cookie-policy" className="text-brand-red underline underline-offset-2">
              cookie policy
            </Link>
            .
          </p>
          <button
            data-testid="cookie-accept"
            onClick={accept}
            className="mt-3 inline-flex items-center rounded-full bg-brand-red px-4 py-2 text-xs font-semibold text-white hover:bg-brand-redDark transition-colors"
          >
            Accetto
          </button>
        </div>
        <button onClick={accept} className="text-white/40 hover:text-white" aria-label="Chiudi">
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};
